export enum GraphQLErrorCode {
    UNAUTHENTICATED = 'UNAUTHENTICATED',
}